/**
 * Error carrying the HTTP status of a failed API response.
 *
 * Lets callers distinguish failure modes — most importantly a 404, which can
 * occur transiently when the frontend has deployed ahead of the backend (a new
 * endpoint isn't live yet). UI can surface "temporarily unavailable" for that
 * case rather than a hard error or a misleading empty state.
 */
export class ApiError extends Error {
  readonly status: number;

  constructor(status: number, message?: string) {
    super(message ?? `API error: ${status}`);
    this.name = "ApiError";
    this.status = status;
  }
}

/** Duck-typed check (survives serialization / React Query's unknown error type). */
export function isApiErrorStatus(error: unknown, status: number): boolean {
  return typeof error === "object" && error !== null && (error as { status?: unknown }).status === status;
}
